import React from "react";

const RightSidebar = ({ children }) => {
  return (
	<aside className="right-sidebar" aria-label="Right sidebar">
	  {children ?? <div className="right-sidebar__placeholder"></div>}

	</aside>

  );
};

export default RightSidebar;